export default {
	"joinOrderPage": {
		"addRoutetips": "เลือกใบตราส่งสินค้าที่จะเพิ่ม"
	},
	"orders": {
		"endPickerTime": "เวลาดำเนินการเสร็จสมบูรณ์ตามจริง",
		"checkedPersonName": "ยืนยันโดย",
		"freightFlag": "มีค่าขนส่งหรือไม่",
		"viewbill": "ดูใบเรียกเก็บเงิน",
		"checkList": "รายการตรวจสอบ",
		"addMark": "ติดตามคำสั่ง",
		"manualAddMark": "การเติมสินค้าสำหรับการขนส่งด้วยตนเอง",
		"temperature": "อุณหภูมิ",
		"clickToSelectAddress": "กรุณาคลิ๊กที่ไอคอนเพื่อเลือกที่อยู่",
		"manualEntry": "การกรอกรายการด้วยตนเอง",
		"accountsReceivable": "ลูกหนี้",
		"rejected": "ปฏิเสธ",
		"submitted": "ยื่นแล้ว",
		"tips1": "กรุณากรอกคำสั่งขนส่งหรือเลือกช่วงเวลาสืบค้น",
		"tips2": "ท่านแน่ใจว่าต้องการปิดคำสั่งขนส่งที่ตรวจสอบแล้วหรือไม่",
		"tips3": "กรุณาเลือกยานพาหนะที่ต้องการเพิ่มการติดตาม",
		"tips4": "กรุณาเลือกเวลา",
		"tips5": "เวลาต้องมากกว่ายานพาหนะ",
		"tips6": "เวลาเริ่มต้น",
		"tips7": "เวลาต้องน้อยกว่ายานพาหนะ",
		"tips8": "เวลาสิ้นสุด",
		"finalCost": "ค่าใช้จ่ายที่ประมาณการ/สรุป (หยวน)",
		"latestDeliveryDt": "เวลาที่ต้องการเริ่ม/เวลาเริ่มจริง",
		"latestReceivedDt": "เวลาที่ต้องการสิ้นสุด/เวลาสิ้นสุดจริง",
		"volume": "จำนวนปริมาตรจริง (ลูกบาศก์เมตร)",
		"weight": "จำนวนน้ำหนักจริง (กิโลกรัม)",
		"packingQty": "จำนวนบรรจุภัณฑ์จริง",
		"taskQty": "จำนวนงาน",
		"checkedPersonDt": "เวลาตรวจสอบ"
	},
	"taskInfo": {
		"actualTemperatureRange": "ช่วงการควบคุมอุณหภูมิจริง",
		"actualPackingQty": "จำนวนบรรจุภัณฑ์จริง",
		"actualGoodsDescription": "รายละเอียดของสินค้าที่จัดส่ง",
		"goodsHandoverInfo": "รายละเอียดการจัดส่งสินค้า",
		"record": "บันทึก",
		"showOperationRecord": "แสดงบันทึกการดำเนินงาน",
		"showRecordInfo": "แสดงข้อมูลบันทึก",
		"deliverGoodsRelevant": "การขนส่งที่เกี่ยวข้อง",
		"pickRelevant": "เกี่ยวข้องกับการรับสินค้า",
		"receiptRelated": "เกี่ยวข้องกับการส่งสินค้า",
		"RelativeException": "ความสัมพันธ์ของข้อยกเว้น",
		"askInformation": "ขอข้อมูล",
		"informationRecord": "บันทึกข้อมูล",
		"fileManagement": "การจัดการไฟล์",
		"addFile": "เพิ่มเอกสารแนบ"
	},
	"tempMonitoring": {
		"noMonitoring": "ไม่มีการควบคุม",
		"screen": "ฟิลเตอร์",
		"refresh": "รีเฟรช",
		"all": "ทั้งหมด",
		"keyPoint": "โฟกัส",
		"grouping": "การจัดกลุ่ม",
		"groupingType": "วิธีแบบกลุ่ม",
		"single": "คำสั่ง",
		"stress": "โฟกัส",
		"arrived": "มาถึงแล้ว",
		"stopMonitoring": "หยุดการควบคุม",
		"monitoring": "ควบคุม",
		"distance": "ระยะทาง",
		"noMonitoringInfo": "ไม่มีข้อมูลการควบคุม",
		"thisOvertemp": "อุณหภูมิสูงเกิน",
		"remainingMileage": "ระยะทางคงเหลือ",
		"driverTelephone": "หมายเลขโทรศัพท์ของพนักงานขับรถ",
		"noticeTips": "แจ้งพนักงานขับรถทาง SMS หรือไม่",
		"messageSentSuccessfully": "ส่งข้อความสำเร็จ",
		"setSuccessfully": "ตั้งค่าสำเร็จ"
	},
	"transportContentInfo": {
		"packingDetail": "รายละเอียดการบรรจุสินค้า",
		"logInfo": "ข้อมูลการดำเนินการ",
		"pickupOperateDt": "เวลายืนยันการรับสินค้า",
		"deliveryOperateDt": "เวลายืนยันการจัดส่งสินค้า",
		"routeCompletionMode": "วิธีดำเนินการให้เสร็จ",
		"electronicReceiptCheckedDt": "เวลายืนยันทางอิเลคทรอนิคส์",
		"electronicReceiptCheckedPersonName": "ผู้ยืนยันทางอิเลคทรอนิคส์"
	},
	"transportInfo": {
		"save": "ยืนยันการบันทึก",
		"goodsValue": "มูลค่าที่แจ้ง",
		"dataCorrect": "การแก้ไขข้อมูล"
	},
	"vehicleList": {
		"workAmount": "ภาระงาน",
		"serviceItemsInfo": "ข้อมูลรายการบริการ",
		"orderServiceItemsInfo": "ข้อมูลรายการคำสั่งบริการ",
		"workServiceItemsInfo": "ข้อมูลรายการงานบริการ"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/track/track.js